import { Component, OnInit, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { Popup } from 'ng2-opd-popup';
import { Router } from '@angular/router';
import { AdminService } from '../../services/admin';
declare var mdtoast: any;
var success_message = mdtoast("Statistique de consultation médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message2 = mdtoast("Statistique de répos médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message3 = mdtoast("Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message4 = mdtoast("Agent inscrit. Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Vous n\'avez pas accès à cette donnée (Agent non inscrit au CMS).', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });



@Component({
  selector: 'app-gestion-medicament',
  templateUrl: './gestion-medicament.component.html',
  styleUrls: ['./gestion-medicament.component.scss']
})
export class GestionMedicamentComponent implements OnInit {
  @ViewChild('popup5') popup5: Popup;
  loginuserCMSActuel: any;
  mode_menu: number;
  agent_iscrit: any;
  id_agent_actuel:any;
  constructor(private router: Router, public adminService: AdminService) { 
    this.agent_iscrit = this.adminService.getUserIscrit();   
    this.id_agent_actuel = this.adminService.getUserIMIscrit(); 
    this.loginuserCMSActuel = this.adminService.getLoginUseCMS();
    if(this.loginuserCMSActuel=="cms_daf"){
      this.mode_menu=1;
     }else{
       this.mode_menu=11;
     }

     if(this.id_agent_actuel == 340909 || this.id_agent_actuel == 34 ){
                this.mode_menu=2;
     }
  }

  ngOnInit() {
  }


  open(id:any){
      if(id==1){
      Swal.fire({
        title: 'LA PHARMACIE MEDICALE',
        icon: 'info',
        text: 'Liste des médicaments par site avec historique des patients.',
        // icone: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, Voir!',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
          //ok btn
          success_message3.show();  
          this.router.navigate(['gestion-med-pharmacie']);    
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      });

    }
    else  if(id==2){
      Swal.fire({
        title: 'L’ENTREPOT',
        icon: 'info',
        text: 'Liste des produits pharmaceutiques et produits consommables au niveau du grand stock.',
        // icone: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, Voir!',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
          //ok btn
          success_message3.show();  
          this.router.navigate(['gestion-med-entrepot']);    
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      });

    }   else  if(id==3){
      Swal.fire({
        title: 'LES PRODUITS LIVRES',
        icon: 'info',
        text: ' Produits pharmaceutiques et consommables livrés.',
        // icone: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, Voir!',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
          //ok btn
          success_message3.show();  
          this.router.navigate(['med-livre']);    
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      });

    } else  if(id==4){
      Swal.fire({
        title: 'LA SITUATION DES MEDICAMENTS',
        icon: 'info',
        text: 'Situation réelle des médicaments reçus par Agent.',
        // icone: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, Voir!',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
          //ok btn
          if(this.agent_iscrit=="OK"){
            success_message3.show();  
            this.router.navigate(['med-consomme']);
          }else{
            error_message.show();
          }
             
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      });

    }
   

  }

  
}
